import React, { useEffect, useState } from 'react';
import ApiProvider from '../../../core/api/ApiProvider';
import { Loader, ModuleContainer, Table } from '../../../core/components';
import { DataTable, emptyDataTable } from '../../../core/components/Table/types/DataTable';
import { InfoMessageService, TranslationService } from '../../../core/services';
import Status from '../../../core/types/Status';

const UpcommingPayments = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [table, setTable] = useState<DataTable>({ ...emptyDataTable });

  const getUpcomingPayments = async () => {
    return await ApiProvider.post<Status<DataTable>>('UpcomingPaymentsModule/GetUpcomingPayments');
  };

  const fetchModel = async () => {
    try {
      setIsLoading(true);
      const data = await getUpcomingPayments();
      if (data.success) {
        const headers = data.data.headers.map((h) => ({
          ...h,
          cssClassNames: `${!h.isVisible && 'hide-d'} ${!h.isVisibleOnMobile && 'hide-m'}`,
        }));

        setTable({
          headers: headers,
          dataRows: data.data.dataRows,
        });
      } else {
        InfoMessageService.error(TranslationService.translate('ErrorSthWentWrong'));
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchModel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ModuleContainer classNames="mt-3">
      <ModuleContainer.Header title={TranslationService.translate('UpcomingPayments')} />
      <ModuleContainer.Body>
        {isLoading ? (
          <Loader />
        ) : (
          <Table
            keyField="PaymentId"
            headers={table.headers}
            rows={table.dataRows}
            paginationProps={{
              hideSizePerPage: true,
              hidePageListOnlyOnePage: true,
            }}
          />
        )}
      </ModuleContainer.Body>
    </ModuleContainer>
  );
};

export default UpcommingPayments;
